function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.5179mm",
    height: "4.2968mm",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M48 1c-3,-2 -24,-2 -36,25l11 11c28,-12 27,-33 26,-36 0,0 0,0 -1,0zm-30 9c-1,1 -9,12 -9,14 -3,0 -9,-3 -9,-3 7,-7 9,-10 12,-11 1,-1 4,-1 6,0zm22 21c-2,1 -13,9 -15,9 0,3 3,9 3,9 7,-7 10,-9 12,-11 1,-2 0,-4 0,-7zm-35 3c3,-3 7,-3 10,0 3,3 3,8 0,10 -3,3 -11,5 -15,5 0,-4 2,-12 5,-15zm32 -21c2,2 2,5 0,7 -3,2 -6,2 -8,0 -2,-2 -2,-5 0,-7 2,-2 5,-2 8,0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.c2707c290fc65c6f8a8a60c04a1617e5.svg";
export { ForwardRef as ReactComponent };